import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { getVersion as getVersionAction } from "../../actions/versionActions";

import packageJson from "../../../package.json";
import getEnvironmentVariable from "../../constants/environments";

const VersionPage = () => {
  const dispatch = useDispatch();
  const [ileggelseServiceVersion, setIleggelseServiceVersion] = useState(null);

  const [/*gitAuthor,*/ gitDate, gitMessage, gitBranch, gitCommit] = [
    // "VITE_GIT_AUTHOR",
    "VITE_GIT_DATE",
    "VITE_GIT_MESSAGE",
    "VITE_GIT_BRANCH",
    "VITE_GIT_COMMIT_HASH",
  ].map((v) => {
    try {
      return getEnvironmentVariable(v);
    } catch {
      return "";
    }
  });

  useEffect(() => {
    async function fetchData() {
      const data = await dispatch(getVersionAction());
      setIleggelseServiceVersion(data);
    }
    fetchData();
  }, [dispatch]);

  return (
    <div style={{ paddingTop: 20, paddingRight: 50, paddingLeft: 50 }}>
      <div>
        ileggelse-client:
        {/* Git author: {gitAuthor}<br/> */}
        <pre>
          Version: {packageJson.version}
          <br />
          Git date: {gitDate}
          <br />
          Git message: {gitMessage}
          <br />
          Git branch: {gitBranch}
          <br />
          Git commit: {gitCommit}
          <br />
        </pre>
      </div>
      <div>
        ileggelse-service:
        <br />
        <pre>{ileggelseServiceVersion}</pre>
      </div>
    </div>
  );
};

export default VersionPage;
